export default __webpack_public_path__ + "static/media/003-shield-1.a22a6c58.png";